export const FLOW_NAME = "driver-analysis-binary";
export type FLOW_TYPE = "driver-analysis-binary";

export const INPUT_DATA = "input-data";

export const OUTCOME_DEFINITION = "outcome-definition"; // For Discrete Y
export const OUTCOME_COLUMN_NAME = "outcome-column";

export const AUGMENTED_FILE = "augmented-data";
